module.exports = __webpack_public_path__ + "img/V68.2ef28fbb.jpg";